import React from 'react';
import { motion } from 'framer-motion';
import { LeadershipSection } from '../components/LeadershipSection';
export function LeadershipPage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.5,
    ease: [0.16, 1, 0.3, 1]
  }} data-id="element-187">
      <div className="pt-24" data-id="element-188">
        <LeadershipSection data-id="element-189" />
      </div>
    </motion.div>;
}